// ======================================================================
// File Name       : SuperUserRegistUpdateContainner.js
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import $ from 'jquery';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Button, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { MODE } from '../../constants/index';
import {
  getSuperUserDetail,
  getEnterpriseList,
  superUserEdit,
  getAllServiceRelation,
  resetInitData,
} from '../../actions/SuperUserAction';
import {
  getSuperuserServiceRoleSettingList,
  getSuperuserServiceRoleList,
  superuserRoleUpdateSetting,
} from '../../actions/SuperuserServiceRoleAction';
import SuperUserCheck from '../../components/superUser/SuperUserCheck';
import SuperUserRegisterUpdate from '../../components/superUser/SuperUserRegisterUpdate';
import EnterpriseSelection from '../../components/EnterpriseSelection';
import { SUPERUSER_LIST } from '../../constants/PathConstants';
import Header from '../../components/Header';
import CustomLink from '../../components/button/CustomLink';
import AboutSuperuserServiceRoleDialog from '../../components/superUser/AboutSuperuserServiceRoleDialog';
import { KEY_ROLE_TYPE } from '../../constants/SuperUserContants';
import { USER_AUTHORITY_ROLE } from '../../constants/AuthorityConstant';
import { hasProperty, isSuperUserL0 } from '../../utils';
import { getSuperuserEnterpriseRoleList } from '../../actions/SuperuserEnterpriseRoleAction';
import AboutSuperuserEnterpriseRoleDialog from '../../components/superUser/AboutSuperuserEnterpriseRoleDialog';
import { hideLoading, showLoading } from '../../utils/PageUtils';

class SuperUserRegisterUpdateContainer extends Component {
  constructor() {
    super();
    this.state = {
      showCheck: false,
      showEnterPrise: false,
      mode: 0,
      superuserDetail: {
        loginIdPasswordSendFlag: 0,
      },
      enterpriseList: [],
      enterpriseInfo: {},
      showAboutDialog: false,
      allServiceCdRoleList: [],
      roleBatchValue: '',
      showDialogRoleSecernId: '',
      showEnterpriseAboutDialog: false,
      showDialogEnterpriseRoleSecernId: '',
      isInit: true, // STEP 10.1.0
    };
    this.handleFormChange = this.handleFormChange.bind(this);
    this.showCheckDlg = this.showCheckDlg.bind(this);
    this.okCheckDlg = this.okCheckDlg.bind(this);
    this.cancelCheckDlg = this.cancelCheckDlg.bind(this);
    this.openAuthorityAboutDialog = this.openAuthorityAboutDialog.bind(this);
    this.onAuthorityAboutOk = this.onAuthorityAboutOk.bind(this);
    this.createRoleListParam = this.createRoleListParam.bind(this);
    this.openEnterpriseAuthorityAboutDialog = this.openEnterpriseAuthorityAboutDialog.bind(this);
    this.onEnterpriseAuthorityAboutOk = this.onEnterpriseAuthorityAboutOk.bind(this);
  }

  componentDidMount() {
    const { dispatch, match, enterpriseCd } = this.props;
    dispatch(resetInitData());
    this.getSuperUserDetail(this.props);
    const mode = match.params.id ? MODE.EDIT_MODE : MODE.NEW_MODE;
    if (mode === MODE.EDIT_MODE) {
      dispatch(getSuperuserServiceRoleSettingList(match.params.id));
    } else {
      dispatch(getAllServiceRelation(enterpriseCd));
    }
  }

  componentWillReceiveProps(nextProps) {
    this.getSuperUserDetail(nextProps);
    // STEP 10.1.0 START
    const { superuserDetail, isInit } = this.state;
    if (isInit && superuserDetail) {
      const { dispatch, match, displayUserType } = nextProps;
      const mode = match.params.id ? MODE.EDIT_MODE : MODE.NEW_MODE;
      const param =
        mode === MODE.EDIT_MODE && isSuperUserL0(displayUserType) ? { enterpriseCd: superuserDetail.enterpriseCd } : null;
      dispatch(getSuperuserServiceRoleList(param));
      dispatch(getSuperuserEnterpriseRoleList(param));
      this.setState({ isInit: false });
    }
    // STEP 10.1.0 END
  }

  getSuperUserDetail(props) {
    let { superuserDetail, allServiceCdRoleList } = this.state;
    const {
      superUser,
      match,
      dispatch,
      superuserServiceRole,
      enterpriseCd,
      superuserEnterpriseRole,
      loginSuperuserEnterpriseRoleSecernId,
      loginSuperuserServiceRoleList,
      displayUserType,
    } = props;
    const {
      superuserInfo,
      enterpriseList,
      enterpriseInfo,
      allServiceRelation,
      authorityInfo: { roleList, bySecernId },
      serviceCdListSorted,
    } = superUser;
    const newAllServiceCdRoleList = allServiceCdRoleList && allServiceCdRoleList.length > 0 
      ? allServiceCdRoleList
      : superUser.allServiceCdRoleList;
    const mode = match.params.id ? MODE.EDIT_MODE : MODE.NEW_MODE;

    if (mode === MODE.NEW_MODE && superuserDetail && !hasProperty(superuserDetail, 'superuserEnterpriseRoleSecernId')) {
      // Step 10.2.0 START
      const newSuperuserDetail = {
        ...superuserDetail,
        ...{ superuserEnterpriseRoleSecernId: loginSuperuserEnterpriseRoleSecernId },
      };

      this.setState({
        superuserDetail: newSuperuserDetail,
      });
      // Step 10.2.0 END
    }

    this.setState({
      mode,
      enterpriseList,
      enterpriseInfo,
      allServiceRelation, // all services belong to superuser
      allServiceCdRoleList: newAllServiceCdRoleList, // service_cd match with super_role_secern_id
      roleBatchValue: '',
      superuserAllServiceRoleList: superuserServiceRole.authorityInfo, // all superuser service role
      enterpriseCd,
      superuserAllEnterpriseRoleList: superuserEnterpriseRole.authorityInfo, // superuser enterprise role
      serviceCdListSorted,
      loginSuperuserEnterpriseRoleSecernId,
      loginSuperuserServiceRoleList,
      isSuperUserL0: isSuperUserL0(displayUserType),
    });
    if (mode === MODE.EDIT_MODE) {
      const superuserDetailInfo = superuserInfo.bySecernId[match.params.id];
      if (superuserDetailInfo) {
        if (superuserDetail && hasProperty(superuserDetail, 'superuserEnterpriseRoleSecernId') &&
          superuserDetail.superuserEnterpriseRoleSecernId !== superuserDetailInfo.superuserEnterpriseRoleSecernId) {
          superuserDetailInfo.superuserEnterpriseRoleSecernId = superuserDetail.superuserEnterpriseRoleSecernId;
        }
        this.setState({
          superuserDetail: superuserDetailInfo,
        });
      }
      else {
        dispatch(getSuperUserDetail(match.params.id));
      }
    } else if (enterpriseList.length === 0) {
      dispatch(getEnterpriseList());
    }
  }

  handleFormChange(event) {
    const { name, value } = event.target;
    let { superuserDetail, loginSuperuserServiceRoleList } = this.state;
    const { allServiceCdRoleList } = this.state;
    if (name === 'passwordChangeFlag' || name === 'isUnlock' || name === 'readOnlyFlag') { // sprint_20230418 #12
      superuserDetail = {
        ...this.state.superuserDetail,
        ...{ [name]: event.target.checked ? 1 : 0 },
      };
    } else if (name.indexOf(KEY_ROLE_TYPE.ROLE_OPTIONS) > -1) {
      const serviceCd = name.split('.').pop();
      allServiceCdRoleList[serviceCd] = value;
      this.setState({
        allServiceCdRoleList,
      });
    } else if (name === KEY_ROLE_TYPE.BATCH_ROLE_OPTIONS) {
      // Step 10.0.0 START
      if (value) {
        const newAllServiceCdRoleList = allServiceCdRoleList;
        Object.keys(allServiceCdRoleList).forEach((serviceCd) => {
          // Step 10.2.0 START
          const isDisable =
            loginSuperuserServiceRoleList[serviceCd] &&
            loginSuperuserServiceRoleList[serviceCd].superuserServiceRoleSecernId !== USER_AUTHORITY_ROLE.ADMIN;
          if (!isDisable) {
            newAllServiceCdRoleList[serviceCd] = value;
          }
          // Step 10.2.0 END
        });
        this.setState({
          allServiceCdRoleList: newAllServiceCdRoleList,
          roleBatchValue: value,
        });
      }
      // Step 10.0.0 END
    } else if (name === 'loginIdPasswordSendFlag') {
      // Step 10.1.0 START
      superuserDetail = {
        ...this.state.superuserDetail,
        ...{ [name]: event.target.checked ? 1 : 0 },
      };
      // Step 10.1.0 END
    }
    else {
      superuserDetail = { ...this.state.superuserDetail, ...{ [name]: value } };
    }
    this.setState({
      superuserDetail,
    });
  }

  backPage() {
    this.props.history.goBack();
  }

  /**
   * Show check dialog
   */
  showCheckDlg() {
    let isValid = true;
    isValid = Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
    if (isValid) {
      this.setState({ showCheck: true });
    }
  }

  /**
   * Handle event when click on キャンセル of check dialog
   *
   */
  cancelCheckDlg() {
    this.setState({ showCheck: false });
  }

  /**
   * Handle event when click on OK of check dialog
   *
   */
  okCheckDlg() {
    const { mode, superuserDetail, allServiceCdRoleList, superuserAllServiceRoleList, enterpriseCd } = this.state;
    const param = {
      editType: mode,
      superuserInfo: {
        superuserName: superuserDetail.superuserName,
        loginId: superuserDetail.loginId,
        superuserSecernId: superuserDetail.superuserSecernId,
        password: mode === MODE.NEW_MODE ? superuserDetail.password : null,
        afterPassword: mode === MODE.EDIT_MODE ? superuserDetail.password : null,
        relationEnterpriseCd: mode === MODE.NEW_MODE ? enterpriseCd : superuserDetail.enterpriseCd,
        mailAddress: superuserDetail.mailAddress,
        remark: superuserDetail.remark,
        passwordChangeFlag: superuserDetail.passwordChangeFlag,
        readOnlyFlag: !!superuserDetail.readOnlyFlag, // sprint_20230418 #12
        lockState: (MODE.NEW_MODE || superuserDetail.isUnlock) ? 0 : superuserDetail.lockState,
        superuserEnterpriseRoleSecernId: superuserDetail.superuserEnterpriseRoleSecernId,
        loginIdPasswordSendFlag:
        superuserDetail.loginIdPasswordSendFlag === 1
          ? superuserDetail.loginIdPasswordSendFlag
          : 0, // STEP 10.1.0
      },
    };
    const self = this;
    this.props.dispatch(showLoading());
    this.props.dispatch(superUserEdit(param)).then(() => {
      const { superUser: { userSecernId } } = this.props;
      const updateRoleSetting = {
        superuserSecernId: userSecernId,
        roleList:
          superuserAllServiceRoleList && Object.keys(superuserAllServiceRoleList.roleList).length
            ? this.createRoleListParam(allServiceCdRoleList)
            : [],
      };
      // Step 10.2.0 START
      if (updateRoleSetting && updateRoleSetting.roleList.length > 0) {
        this.props.dispatch(superuserRoleUpdateSetting(updateRoleSetting)).then(() => {
          this.props.dispatch(hideLoading());
          self.props.history.push(SUPERUSER_LIST);
        });
      } else {
        this.props.dispatch(hideLoading());
        self.props.history.push(SUPERUSER_LIST);
      }
      // Step 10.2.0 END
    });
    this.setState({ showCheck: false });
  }

  createRoleListParam(allServiceCdRoleList) {
    const { loginSuperuserServiceRoleList, mode } = this.state;
    const roleListParam = [];
    Object.keys(allServiceCdRoleList).map((cur) => {
      // Step 10.2.0 START
      const isDisable =
        mode === MODE.EDIT_MODE &&
        loginSuperuserServiceRoleList[cur] &&
        loginSuperuserServiceRoleList[cur].superuserServiceRoleSecernId !== USER_AUTHORITY_ROLE.ADMIN;
      !isDisable && roleListParam.push({ superuserServiceRoleSecernId: allServiceCdRoleList[cur], serviceCd: cur });
      // Step 10.2.0 END
    });
    return roleListParam;
  }

  /**
   * Show more information when click
   */
  openAuthorityAboutDialog(roleValue) {
    this.setState({ showAboutDialog: true, showDialogRoleSecernId: roleValue });
  }

  onAuthorityAboutOk() {
    this.setState({ showAboutDialog: false, showDialogRoleSecernId: '' });
  }

  openEnterpriseAuthorityAboutDialog(roleValue) {
    this.setState({ showEnterpriseAboutDialog: true, showDialogEnterpriseRoleSecernId: roleValue});
  }

  onEnterpriseAuthorityAboutOk() {
    this.setState({ showEnterpriseAboutDialog: false, showDialogEnterpriseRoleSecernId: '' });
  }

  render() {
    const {
      superuserDetail,
      enterpriseList,
      mode,
      showCheck,
      showEnterPrise,
      enterpriseCd,
    } = this.state;
    this.refsToValidate = [];
    return (
      <div>
        { mode === MODE.NEW_MODE && (
            <CustomLink
            className="margin-right-7 url-list"
            to={SUPERUSER_LIST}
            text="SuperUser管理に戻る"
            icon="bi bi-chevron-left"
          />
        )}
        <Header name={mode === MODE.NEW_MODE ? 'SuperUser情報の新規登録' : 'SuperUser情報の編集'}/>
        <p className="margin-top-10 margin-bottom-10">
          {mode === MODE.NEW_MODE ? '登録する項目を指定してください' : '編集する項目を指定してください'}
        </p>
        <SuperUserRegisterUpdate
          {...this.state}
          ref={(ref) => {
            if (ref) {
              this.refsToValidate.push(ref);
            }
          }}
          handleChange={this.handleFormChange}
          onChangeLockState={this.onChangeLockState}
          showCheckDlg={this.showCheckDlg.bind(this)}
          openAuthorityAboutDialog={this.openAuthorityAboutDialog}
          openEnterpriseAuthorityAboutDialog={this.openEnterpriseAuthorityAboutDialog}
          loginIdPasswordSendFlag={superuserDetail.loginIdPasswordSendFlag}
        />

        <Form.Group className="margin-top-20 text-center">
          <Col className="text-center">
            {mode === MODE.EDIT_MODE &&
              <Button className="margin-10" onClick={this.backPage.bind(this)}>
                キャンセル
              </Button>}
            <Button
              variant="primary"
              className="btn-96 margin-10"
              onClick={this.showCheckDlg.bind(this)}
            >
              OK
            </Button>
          </Col>
        </Form.Group>
        <SuperUserCheck {...this.state} onCancel={this.cancelCheckDlg} onOK={this.okCheckDlg} />
        {this.state.showDialogRoleSecernId && (
          <AboutSuperuserServiceRoleDialog
            {...this.state}
            showModal={this.state.showAboutDialog}
            onAuthorityAboutOk={this.onAuthorityAboutOk}
          />
        )}
        {this.state.showDialogEnterpriseRoleSecernId && (
          <AboutSuperuserEnterpriseRoleDialog
            {...this.state}
            showModal={this.state.showEnterpriseAboutDialog}
            onEnterpriseAuthorityAboutOk={this.onEnterpriseAuthorityAboutOk}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { superUser, authed, service, superuserServiceRole, superuserEnterpriseRole } = state;
  const {
    authedUser: {
      enterpriseCd,
      userInfo: { displayUserType },
      loginSuperuserEnterpriseRoleSecernId,
      loginSuperuserServiceRoleList,
    },
  } = authed;
  return {
    superUser,
    enterpriseCd,
    superuserServiceRole,
    displayUserType,
    superuserEnterpriseRole,
    loginSuperuserEnterpriseRoleSecernId,
    loginSuperuserServiceRoleList,
  };
};

export default connect(mapStateToProps)(SuperUserRegisterUpdateContainer);
